// import { authPath } from "@routes/auth/path";

import { authManagement } from "@routes/authManagement/path";
import { booksPath } from "@routes/facultyMember/articlesAndBook/book/path";
import { conferencePapersPath } from "@routes/facultyMember/articlesAndBook/conferencePaper/path";
import { journalPapersPath } from "@routes/facultyMember/articlesAndBook/journalPaper/path";
import { researchProposalPath } from "@routes/facultyMember/research/path";
import { mediaManagementPath } from "@routes/facultyMember/media/path";
import { achievementManagementPath } from "@routes/facultyMember/achievement/path";
import { laboratoryPath } from "@routes/facultyMember/laboratory/path";
import { studentPath } from "@routes/facultyMember/student/path";
import { coursesPath } from "@routes/facultyMember/courseManagement/courses/path";
import { courseChaptersPath } from "@routes/facultyMember/courseManagement/courseChapter/path";
import { courseChapterExamsPath } from "@routes/facultyMember/courseManagement/courseChapterExam/path";
import { courseChapterExercisePath } from "@routes/facultyMember/courseManagement/courseChapterExercise/path";
import { courseChapterProjectsPath } from "@routes/facultyMember/courseManagement/courseChapterProjects/path";
import { courseChapterSlidesPath } from "@routes/facultyMember/courseManagement/courseChapterSlides/path";
import { facultyPath } from "@routes/admin/facultyManagement/faculty/path";
import { facultyAcademicGroupsPath } from "@routes/admin/facultyManagement/facultyAcademicGroups/path";
import { academicGroupPath } from "@routes/admin/facultyManagement/academicGroup/path";
import { facultyAcademicGroupMembersPath } from "@routes/admin/facultyManagement/facultyAcademicGroupMembers/path";
import { academicGroupMembersPath } from "@routes/admin/facultyManagement/academicGroupMembers/path";
import { membersOfFacultyPath } from "@routes/admin/facultyManagement/membersOfFaculty/path";
import { crawlerManagementPath } from "@routes/admin/crawler";
import { facultyMembersPath } from "@routes/admin/usersManagement/facultyMembers/path";
import { staffsPath } from "@routes/admin/usersManagement/staff/path";
import { usersPath } from "@routes/admin/usersManagement/users/path";
import { homePath } from "@routes/common/home";
import { pwaPath } from "@routes/common/pwa/path";
import { editProfilePath } from "@routes/common/editProfile";
import { changePasswordPath } from "@routes/common/changePassword";
import { notificationsSettingPath } from "@routes/common/notificationsSetting";

export type { IFacultyRouteParams } from "@routes/admin/facultyManagement/faculty/path";
export type { IMembersOfFacultyRouteParams } from "@routes/admin/facultyManagement/membersOfFaculty/path";
export type { IFacultyAcademicGroupsRouteParams } from "@routes/admin/facultyManagement/facultyAcademicGroups/path";
export type { IFacultyAcademicGroupMembersRouteParams } from "@routes/admin/facultyManagement/facultyAcademicGroupMembers/path";
export type { IAcademicGroupRouteParams } from "@routes/admin/facultyManagement/academicGroup/path";
export type { IAcademicGroupMembersRouteParams } from "@routes/admin/facultyManagement/academicGroupMembers/path";

export type { ICrawlerManagementRouteParams } from "./admin/crawler";
export type { IUsersRouteParams } from "./admin/usersManagement/users/path";
export type { IFacultyMembersRouteParams } from "./admin/usersManagement/facultyMembers/path";
export type { IStaffsRouteParams } from "./admin/usersManagement/staff/path";

export type { IBooksRouteParams } from "./facultyMember/articlesAndBook/book/path";
export type { IConferencePapersRouteParams } from "./facultyMember/articlesAndBook/conferencePaper/path";
export type { IJournalPapersRouteParams } from "./facultyMember/articlesAndBook/journalPaper/path";

export type { IMediaManagementRouteParams } from "./facultyMember/media/path";
export type { ILaboratoryRouteParams } from "./facultyMember/laboratory/path";
export type { IResearchProposalRouteParams } from "./facultyMember/research/path";
export type { IStudentRouteParams } from "./facultyMember/student/path";
export type { IAchievementManagementRouteParams } from "./facultyMember/achievement/path";
export type { ICoursesRouteParams } from "./facultyMember/courseManagement/courses/path";
export type { ICourseChaptersRouteParams } from "./facultyMember/courseManagement/courseChapter/path";
export type { ICourseChapterSlidesRouteParams } from "./facultyMember/courseManagement/courseChapterSlides";
export type { ICourseChapterExerciseRouteParams } from "./facultyMember/courseManagement/courseChapterExercise";
export type { ICourseChapterProjectsRouteParams } from "./facultyMember/courseManagement/courseChapterProjects";
export type { ICourseChapterExamsRouteParams } from "./facultyMember/courseManagement/courseChapterExam";

export type { IHomeRouteParams } from "./common/home/path";
export type { IEditProfileRouteParams } from "./common/editProfile/path";
export type { IChangePasswordRouteParams } from "./common/changePassword/path";
export type { INotificationsSettingRouteParams } from "./common/notificationsSetting/path";

export const path = {
  pwaPath,
  // auth: authPath,
  homePath,
  facultyPath,
  facultyAcademicGroupsPath,
  academicGroupPath,
  facultyMembersPath,
  usersPath,
  staffsPath,
  crawlerManagementPath,
  editProfilePath,
  changePasswordPath,
  notificationsSettingPath,
  booksPath,
  journalPapersPath,
  conferencePapersPath,
  researchProposalPath,
  achievementManagementPath,
  mediaManagementPath,
  studentPath,
  laboratoryPath,
  coursesPath,
  facultyAcademicGroupMembersPath,
  academicGroupMembersPath,
  courseChapterExamsPath,
  courseChapterExercisePath,
  courseChapterProjectsPath,
  courseChapterSlidesPath,
  courseChaptersPath,
  membersOfFacultyPath,
  authManagement,
};
